"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactDataGrid = _interopRequireDefault(require("react-data-grid"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

require("./React-Data-Grid-Overrides.css");

var _RemoveSelectAllRenderer = _interopRequireDefault(require("./RemoveSelectAllRenderer"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};

  if (obj != null) {
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var TotalHolder = _styledComponents["default"].div.withConfig({
  displayName: "DataTable__TotalHolder",
  componentId: "td651-0"
})(["&&&{margin-top:-1px;font-weight:bold;.react-grid-Cell{background:#f7f7f7;}}"]);

var enrichColumns = function enrichColumns(columns, sortColumn, sortDirection) {
  var newColumns = _lodash["default"].cloneDeep(columns);

  var finalColumns = [];
  newColumns.forEach(function (column) {
    if (!column.resizable) {
      column.resizable = true;
    }

    finalColumns.push(checkForSortedColumn(column, sortColumn, sortDirection));
  });
  return finalColumns;
};

var checkForSortedColumn = function checkForSortedColumn(column, sortColumn, sortDirection) {
  if (!column.cellClass) {
    column.cellClass = "";
  }

  if (sortColumn) {
    if (column.key.toLowerCase() === sortColumn.toLowerCase() && sortDirection.toUpperCase() !== "NONE") {
      column.cellClass += " sorted-col";
    }
  }

  column.cellClass += " " + column.key + "-selector-id";
  return column;
};

var DataTable = function DataTable(_ref) {
  var sortFunc = _ref.sortFunc,
      columns = _ref.columns,
      sortColumn = _ref.sortColumn,
      sortDirection = _ref.sortDirection,
      data = _ref.data,
      height = _ref.height,
      minColumnWidth = _ref.minColumnWidth,
      headerRowHeight = _ref.headerRowHeight,
      rowSelection = _ref.rowSelection,
      rowHeight = _ref.rowHeight,
      rowRenderer = _ref.rowRenderer,
      selectAll = _ref.selectAll,
      hasTotals = _ref.hasTotals,
      rest = _objectWithoutProperties(_ref, ["sortFunc", "columns", "sortColumn", "sortDirection", "data", "height", "minColumnWidth", "headerRowHeight", "rowSelection", "rowHeight", "rowRenderer", "selectAll", "hasTotals"]);

  var totalGrid = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      expandedRows = _useState2[0],
      setExpandedRows = _useState2[1];

  (0, _react.useEffect)(function () {
    if (hasTotals) {
      window.addEventListener("scroll", checkScroll, true);
    }

    return function () {
      if (hasTotals) {
        window.removeEventListener("scroll", checkScroll, true);
      }
    };
  }, [hasTotals]);

  var checkScroll = function checkScroll(evt) {
    var cs = evt.target.className;

    if (cs === "react-grid-Canvas") {
      var scrollLeft = evt.target.scrollLeft;

      try {
        if (totalGrid) {
          totalGrid.refs.base.refs.header.setScrollLeft(scrollLeft);
        }
      } catch (e) {}
    }
  };

  var rowGetter = function rowGetter(index) {
    return data[index];
  };

  var getTotals = function getTotals() {
    return data[data.length - 1];
  };

  var finalColumns = enrichColumns(columns, sortColumn, sortDirection);
  return _react["default"].createElement("div", null, _react["default"].createElement(_reactDataGrid["default"], _extends({
    id: "react-data-grid",
    columns: finalColumns,
    onGridSort: sortFunc,
    rowGetter: rowGetter,
    rowsCount: hasTotals ? data.length - 1 : data.length,
    minHeight: height,
    sortColumn: sortColumn,
    sortDirection: sortDirection,
    minColumnWidth: minColumnWidth,
    headerRowHeight: headerRowHeight,
    rowHeight: rowHeight,
    rowSelection: rowSelection,
    selectAllRenderer: selectAll ? undefined : _RemoveSelectAllRenderer["default"],
    rowRenderer: rowRenderer
  }, rest)), hasTotals && _react["default"].createElement(TotalHolder, null, _react["default"].createElement(_reactDataGrid["default"], {
    className: "total-row",
    ref: totalGrid,
    id: "total-row",
    columns: finalColumns,
    rowGetter: getTotals,
    rowsCount: 1,
    minHeight: 33,
    headerRowHeight: 1,
    rowHeight: 30
  })));
};

DataTable.propTypes = {
  /** Column Definitions more documentation can be provided 'https://adazzle.github.io/react-data-grid/docs/ReactDataGrid#columns-required' */
  columns: _propTypes["default"].array.isRequired,

  /** The data to display in the grid */
  data: _propTypes["default"].array.isRequired,

  /** Function that is called when the grid is sorted returning the column and direction */
  sortFunc: _propTypes["default"].func,

  /** The column that is currently sorted */
  sortDirection: _propTypes["default"].string,

  /** The direction that the grid is currently sorted in */
  sortColumn: _propTypes["default"].string,

  /** The height of the grid in pixels */
  height: _propTypes["default"].number,

  /** Minimum width of the layout of the grid */
  minColumnWidth: _propTypes["default"].number,

  /** Height of the header row */
  headerRowHeight: _propTypes["default"].number,

  /** Height of each row */
  rowHeight: _propTypes["default"].number,

  /** Row selection object see 'https://adazzle.github.io/react-data-grid/docs/ReactDataGrid#rowselection' for more documentation */
  rowSelection: _propTypes["default"].object,

  /** Should we show the select all option if using row selection */
  selectAll: _propTypes["default"].bool,

  /** Custom Row Renderer */
  rowRenderer: _propTypes["default"].func,

  /** Does the table have a totals table column */
  hasTotals: _propTypes["default"].bool
};
DataTable.defaultProps = {
  height: 400,
  sortFunc: function sortFunc() {},
  minColumnWidth: 100,
  headerRowHeight: 35,
  rowHeight: 35,
  selectAll: true,
  hasTotals: false,
  sortDirection: "",
  sortColumn: "",
  rowSelection: null,
  rowRenderer: null
};
var _default = DataTable;
exports["default"] = _default;